import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DataTask3600To3699Service {

  constructor() { }
}
